module.exports = __webpack_public_path__ + "img/infoblokk_kedv_final_felso_cmyk_en_ERFA.685ebde8.png";